import { render, staticRenderFns } from "./lessonMenu.vue?vue&type=template&id=4976f514&"
import script from "./lessonMenu.vue?vue&type=script&lang=js&"
export * from "./lessonMenu.vue?vue&type=script&lang=js&"
import style0 from "./lessonMenu.vue?vue&type=style&index=0&id=4976f514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports